import React, { useState } from "react";
import TimelineHeader from "./TimelineHeader";
import { ShieldAlert } from "lucide-react";
import UploadModal from "../../components/Modal/TimelineUploadModal";
const InnovatorForm = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState("Class IX");
  const [checkedItems, setCheckedItems] = useState({
    stem: false,
    coding: true,
    robotics: false,
    logical: true,
    clubs: true,
  });

  const classes = ["Class IX", "Class X", "Class XI", "Class XII"];

  const handleCheckboxChange = (item) => {
    setCheckedItems((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const checklistItems = [
    {
      id: "stem",
      text: "Participate in STEM Olympiads",
      checked: checkedItems.stem,
    },
    {
      id: "coding",
      text: "Start coding (Python, Java)",
      checked: checkedItems.coding,
    },
    {
      id: "robotics",
      text: "Initiate a mini robotics or coding project",
      checked: checkedItems.robotics,
    },
    {
      id: "logical",
      text: "logical reasoning through coding platforms (Code.org, Scratch)",
      checked: checkedItems.logical,
    },
    {
      id: "clubs",
      text: "Join school science/tech clubs & present a mini project",
      checked: checkedItems.clubs,
    },
  ];

  return (
    <>
      <TimelineHeader />
      <div className=" p-6 bg-gray-50 min-h-screen">
        {/* Header Tabs Card */}
        <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-8">
          <div className="flex justify-center space-x-3 mb-4">
            {classes.map((className) => (
              <button
                key={className}
                onClick={() => setSelectedClass(className)}
                className={`relative pt-4 px-4 text-[18px] font-altis font-bold leading-[100%] tracking-[0px] text-center transition-colors
          ${
            selectedClass === className
              ? "border-t-2 border-[#572575] text-[#572575] before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-10 before:bg-gradient-to-b before:from-[#3B035E] before:to-white before:opacity-20"
              : "border-t-2 border-transparent text-[#555555] hover:text-gray-700"
          }`}
              >
                {className}
              </button>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-md p-8 space-y-6">
          {/* Heading */}
          <h2 className="font-siromi text-[26px] font-normal text-[#572575] mb-6">
            Innovator
          </h2>

          {/* Question + Image Row */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left Column - Checklist */}
            <div className="space-y-7">
              {checklistItems.map((item) => (
                <div
                  key={item.id}
                  className={`flex items-start space-x-3 p-4 rounded-lg transition-colors ${
                    item.checked ? "bg-[#F9F0F8]" : "bg-[#EEEEEE66]"
                  }`}
                >
                  <div className="relative flex items-center">
                    <input
                      type="checkbox"
                      checked={item.checked}
                      onChange={() => handleCheckboxChange(item.id)}
                      className="w-6 h-6 rounded-lg border-2 border-gray-300 checked:bg-[#9D0385] checked:border-[#9D0385] appearance-none cursor-pointer"
                    />
                    {/* Checkmark */}
                    <span
                      className={`absolute left-0 top-0 w-6 h-6 flex items-center justify-center pointer-events-none text-white text-lg font-bold ${
                        item.checked ? "block" : "hidden"
                      }`}
                    >
                      ✓
                    </span>
                  </div>

                  <label
                    className={`font-altis text-[14px] font-bold leading-[100%] text-center ${
                      item.checked
                        ? "text-[#9D0385]"
                        : "text-[#111111] font-normal"
                    }`}
                  >
                    {item.text}
                  </label>
                </div>
              ))}
            </div>

            {/* Right Column - Image */}
            <div className="hidden lg:flex items-center justify-center h-[400px] w-[470px] ">
              <img src="/timeline/CustomizeTimelineRight.png" alt="rightImg" />
            </div>
          </div>

          {/* Upload + Submit Row */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <ShieldAlert className="text-[#FAAE2D] w-6 h-6" />

              <span className="font-altis text-[16px] leading-[20px] tracking-[0.1px] font-normal text-[#000000]">
                Upload your SOP/LoR Documents
              </span>
              <button
                onClick={() => setIsUploadOpen(true)}
                className="px-4 py-2 font-altis font-bold text-[12px] leading-[100%] tracking-[0px] text-center align-middle text-[#572575] bg-white border border-[#572575] rounded-md hover:bg-[#572575] hover:text-white transition-colors shadow-md"
              >
                Upload Now
              </button>
            </div>

            <button className="px-6 py-2 bg-[#572575] text-white rounded-md hover:bg-[#572575] transition-colors font-altis font-bold text-[16px] leading-[100%] text-center">
              Submit
            </button>
          </div>
        </div>
      </div>
      <UploadModal
        isOpen={isUploadOpen}
        onClose={() => setIsUploadOpen(false)}
      />
    </>
  );
};

export default InnovatorForm;
